import mainService from "./mainService";

export function records() {
    return mainService
        .get("/admin/topics/list")
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}



// WEBPACK FOOTER //
// ./src/services/post.jsx